// ----------------------------------------------------------------------------
// Helper: Storefront API GraphQL caller
// ----------------------------------------------------------------------------
//
// Query example - Get specific product metafield through id.
// const query = `{
//   product(id:"gid://shopify/Product/7167381930032"){
//     title
//     metafield(key:"hidden_product",namespace:"iamota"){
//       id
//       key
//       value
//     }
//   }
// }`;
//
// ----------------------------------------------------------------------------

/**
 * Returns JSON response based on GraphQL query from the Shopify Storefront API.
 *
 * @param {string} graphqlQuery String in GraphQL format (see example above).
 * @return {JSON} API json response.
 */

const storefrontQuery = async (graphqlQuery) => {
    try {
        let storefrontToken = "";
        var host = window.location.hostname;

        switch (host) {
            case "dsc-uk.myshopify.com":
            case "uk.dollarshaveclub.com":
                storefrontToken = "0280051066af41ae8f85137fc8feebd5";
                break;
            case "au-shopify.dollarshaveclub.com":
            case "dsc-au.myshopify.com":
            case "au.dollarshaveclub.com":
                storefrontToken = "f14bb697960f61f19cd599cf9b21d996";
                break;
            case "dollar-shave-club-store.myshopify.com":
            case "us.dollarshaveclub.com":
                storefrontToken = "2226204c9a678276efcb7d5b13a7ab8b";
                break;
            case "ca.dollarshaveclub.com":
            case "dsc-ca.myshopify.com":
                storefrontToken = "e8dfdc8423e369ceea348646b4afe472";
                break;
            case "engineering-release.myshopify.com":
                storefrontToken = "42f8d75862b7b6ba7366f074defec624";
                break;
            default:
                break;
        }

        const primary_url = `https://${host}`;
        let response = await fetch(`${primary_url}/api/graphql.json`, {
            method: "POST",
            headers: {
                "Content-Type": "application/graphql",
                "Access-Control-Origin": "*",
                "X-Shopify-Storefront-Access-Token": storefrontToken,
            },
            body: graphqlQuery,
        });

        return await response.json();
    } catch (error) {
        console.error(error);
    }
};

export default storefrontQuery;
